export enum ProfileForm {
  createProfessionalProfile = 'createProfessionalProfile',
  editProfessionalProfile = 'editProfessionalProfile',
  previewProfile = 'previewProfile',
}
